import './App.css';
import React from 'react';
import Slider from 'react-slick';
import Navbar from './components/navbar';
import Technologies from './components/technologies';
import SideBar from './components/sidebar';
import Education from './components/education';
import Certificate from './components/certificate';
import Contactform from './components/form';
import Project from './components/project';

import 'slick-carousel/slick/slick.css';
import 'slick-carousel/slick/slick-theme.css';

function App() {
  const projects = [
    {
      projectName: 'My portfolio',
      projectImage: 'portfolio',
      languages: [
        {name: 'React', image: 'react'},
        {name: 'JavaScript', image: 'javascript'},
        {name: 'HTML', image: 'html'},
        {name: 'CSS', image: 'css'}
      ],
      url: 'https://calm-heliotrope-a66bd9.netlify.app/'
    },
  ]


  const sliderSettings = {
    dots: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
  };

  return (
    <div className="App">
      <header>
        <Navbar />
      </header>
      
      <section className='home' id='home'>
        <div className='information'>
          <div className='text-info'>
            <h1 className='h1-home'>Miguel Ángel Castrillón Balvin</h1>
            <p className='p-home'>Full Stack Developer</p>
            <a href={require('./docs/CVMIGUELANGELCASTRILLONBALVIN.pdf')} download='CVMIGUELANGELCASTRILLONBALVIN.pdf'><button className='downloader'>Download my CV</button></a>
            
          </div>
          <img src={require('./img/image-home.png')} alt='Imagen Home' className='img-home' />
        </div>
        <SideBar />
      </section>
      <h1 class="h1-technologies" id="technologies">Technologies</h1>
      <section class="technologies-section">
        <div className='technology-category'>
          <h2>Languages</h2>
          <div className='technology-container'>
            <Technologies name="Python" imagen="python" alt="Python"/>
            <Technologies name="TypeScript" imagen="typescript" alt="Typescript"/>
            <Technologies name="Java" imagen="java" alt="Java" />
            <Technologies name="HTML" imagen="html" alt="HTML"/>
            <Technologies name="CSS" imagen="css" alt="CSS"/>
            <Technologies name="SQL" imagen="sql" alt="SQL"/>  
          </div>
        </div>
        <div className='technology-category'>
          <h2>Databases</h2>
          <div className='technology-container'>
            <Technologies name="MySQL" imagen="mysql" alt="MySQL"/>
            <Technologies name="PostgreSQL" imagen="posgresql" alt="PostgreSQL"/>
            <Technologies name="SQLite" imagen="sqlite" alt="SQLite"/>
          </div>
        </div>
        <div className='technology-category'>
          <h2>Frameworks</h2>
          <div className='technology-container'>
            <Technologies name="Django" imagen="django" alt="Django"/>
            <Technologies name="Angular" imagen="angular" alt="angular"/>
            <Technologies name="SpringBoot" imagen="spring" alt="SpringBoot"/>
          </div>
        </div>
      </section>
      <h1 id='education'>Education</h1>
      <section className='education-section'>
        <Education />
      </section>
      <h1 id='certificates'>
        Certificates
        <br />
        <a className='allCertificates' href="https://drive.google.com/drive/folders/15w0ylOH15s6OQ77Bgur545kCyjhTKA55?usp=drive_link" target='_blank' rel='noreferrer'>view all certificates</a>
      </h1>
      <section className='certificates-section'>
        <div className='certificate-large'>
          <Certificate file="1XRhhKu9cXXhXg2AIenIyZE7IVJCpBWvq" title="Tecnico en desarrollo de software" />
        </div>
        <div className='certificate-small'>
          <Certificate file="18vuEMr2v3gyVk1M-Bts9g_1pRe_7XD9_" title="Controles y seguridad informatica" />
          <Certificate file="1-ErgVuDn3RU2xEY6eNVX-MoAIhCkS8f-" title="Creacion de APIS con Django"  />
          <Certificate file="1TAavQjrNawfdMCXtHNYIg77fyrf4CJgy" title="Git y GitHub profesional" />
          <Certificate file="1aeqpCNk_xNBEBtTLBPzwSXQsNY9XiKwg" title="Desarrollo de python avanzado" />
          <Certificate file="16LTBGDzVc_W1cY8QYMV_Q2fktCmYAyZX" title="Especializacion en python y django" />
          <Certificate file="188MRnDptcz77krv680UVEnzbTS4tKWvw" title="JavaScript basico" />
          <Certificate file="1KBVTBqznqrew32iYRd5tELihPdfUsoO5" title="SQL basico" />
          <Certificate file="167hrjrQrgZ996vzrTzrI_K1jqLMIZWqQ" title="Python basico" />
          <Certificate file="1A6X4bYgDL1hLjz1AfNArHSP5l-eHNwNh" title="Resolucion de problemas" />
          <Certificate file="1o_iEDM-GBHpdtthm_fOlfi2bjn_dCveW" title="Introduccion a paginas web" />
          <Certificate file="11GmoRI9JFD5dDMIpK9Fi00G4nBTDkEGa" title="Usar un editor de codigo" />
          <Certificate file="122zNtCmgnarUtp4k4xQ46ZAZSvqQPe-e" title="ProFuturo" />
        </div>
        
      </section>
      

      <h1 id='projects'>Projects</h1>
      <section className='projects-section'>
        <Slider className='slider-projects' {...sliderSettings} slick-offset={10}>
          {projects.map((project, index) => (
            <div key={index}>
              <Project  
                projectName={project.projectName} 
                languages={project.languages}
                url={project.url}
                projectImage={project.projectImage} 
              />
            </div>
          ))}
        </Slider>
      </section>

      <h1 id='contact'>contact me</h1>
      <section className='contact-form'>
        <Contactform />
      </section>
      <footer>
        <p>Site desing by Miguel Ángel Castrillón Balvin</p>
      </footer>
    </div>
   
  );
}

export default App;
